/**
 * AppLayout Component
 * Main layout wrapper with header, navigation, and content area
 */

import React from 'react';
import { Box } from '@mui/material';
import { Header } from './Header';
import { Navigation } from './Navigation';

export const AppLayout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Header />

      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        <Navigation />

        <Box
          component="main"
          sx={{
            flex: 1,
            overflow: 'auto',
            bgcolor: 'background.default',
            p: 3
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
